import { render, staticRenderFns } from "./Vallesur.vue?vue&type=template&id=0b6bce43"
import script from "./Vallesur.vue?vue&type=script&lang=js"
export * from "./Vallesur.vue?vue&type=script&lang=js"
import style0 from "./Vallesur.vue?vue&type=style&index=0&id=0b6bce43&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports